var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('b-card-title',[_vm._v("Thời Khóa Biểu")])],1),_c('b-card-body',[_c('schedule-time',{attrs:{"form":_vm.form.scheduleTime}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }